"use client";

import { FOUNDER_VIDEO } from "@/lib/founder-video";
import { SiteVideoPlayer } from "@/components/ownly/SiteVideoPlayer";

/**
 * The founder video, when there is one.
 *
 * Returns null when no video is configured, and the page renders its static hero
 * instead. See `src/lib/founder-video.ts` for why that is a different layout rather
 * than an empty frame.
 */
export function FounderVideo() {
  if (!FOUNDER_VIDEO) return null;
  return <SiteVideoPlayer video={FOUNDER_VIDEO} />;
}
